import Button from '@rezdy/components/Button';
import Grid from '@rezdy/components/Grid';
import { H4 } from '@rezdy/components/Heading';
import TextStyle from '@rezdy/components/TextStyle';
import React from 'react';
import { HUBSPOT_SIGN_UP, SIGN_IN } from '../constants/routes';
import { push } from '../services/routing';
import { MarketingLayout } from './Layout/MarketingLayout';

export const InvalidIdpUser = () => {
    return (
        <MarketingLayout>
            <Grid.Container rowGap="24px">
                <TextStyle align="left">
                    <H4 style={{ margin: 0 }}>Invalid single sign-on login</H4>
                </TextStyle>
                <TextStyle as="p" style={{ margin: 0 }}>
                    Sorry, an account with that email does not exist in Rezdy.
                </TextStyle>
                <TextStyle as="p" style={{ margin: 0 }}>
                    Login with a different account or create a new one by clicking one of the buttons below.
                </TextStyle>
                <Grid.Container cols={2} colGap="12px">
                    <Grid.Cell>
                        <Button type="submit" action="secondary" width="100%" onClick={() => push(SIGN_IN)} reversed>
                            Back to login
                        </Button>
                    </Grid.Cell>
                    <Grid.Cell>
                        <Button type="submit" action="primary" width="100%" onClick={() => push(HUBSPOT_SIGN_UP)}>
                            Create account
                        </Button>
                    </Grid.Cell>
                </Grid.Container>
            </Grid.Container>
        </MarketingLayout>
    );
};
